module.exports = __webpack_public_path__ + "static/img/anxun31.e6b6a7cd.png";